<template>
    <main-layout>
        <div id="applications" class="page animated fadeIn">
            <v-row align="center">
                <v-col cols="12"><h1 class="mb-0">Users</h1></v-col>
                <v-col cols="12" lg="2">
                    <v-text-field
                            dark
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" lg="1" >
                    <v-select
                            :items="[5,10,25,50]"
                            solo
                            v-model="itemsPerPage"
                            hide-details
                    ></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-col cols="6" lg="2" align-self="center" class="text-right">
                    <form-dialog
                            :form-title="formTitle"
                            activator-text="New User"
                            :dialog="dialog"
                            :success-message="successMessage"
                            :form-loading="formLoading"
                            :data-sent="dataSent"
                            :valid="valid"
                            @dialogOpen="dialog = true"
                            @dialogClose="close"
                            @formSubmit="save"
                    >
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="editedItem.name" :rules="rules.name" label="Name"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="editedItem.email" :rules="rules.email" label="Email"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-switch v-model="editedItem.is_admin" label="Is Admin"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-switch @change="handleStatusChange" :input-value="userStatusBool" label="Status"></v-switch>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                        v-model="editedItem.office_id"
                                        :items="offices"
                                        item-text="name"
                                        item-value="id"
                                        label="Select Office"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                        v-model="editedItem.role_id"
                                        :items="roles"
                                        item-text="name"
                                        item-value="id"
                                        label="Select Role"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </form-dialog>
                </v-col>
            </v-row>
            <!-- User data table -->
            <v-container fluid class="px-0 px-lg-3">
            <v-card>
                <v-data-table
                        :headers="headers"
                        :items="getUsers"
                        :search="search"
                        :custom-filter="customFilter"
                        :items-per-page="itemsPerPage"
                        :page.sync="page"
                        :expanded.sync="expanded"
                        hide-default-footer
                        multi-sort
                        :sort-by="'status'"
                        :sort-desc="false"
                        :loading="preloader" loading-text="Loading... Please wait"
                        show-expand
                        :single-expand="false"
                        class="elevation-1"
                        @page-count="pageCount = $event"
                >
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                                small
                                class="mr"
                                @click="editItem(item)"
                        >
                            mdi-pencil
                        </v-icon>
<!--                        <v-icon-->
<!--                                small-->
<!--                                @click="deleteItem(item)"-->
<!--                        >-->
<!--                            mdi-delete-->
<!--                        </v-icon>-->
                    </template>
                    <template v-slot:item.role="{ item }">
                        <v-chip v-if="item.Roles.length && item.Roles[0].name" small color="primary darken-1" @click="handleRoleClick(item)">
                            {{item.Roles[0].name}}
                        </v-chip>
                    </template>
                    <template v-slot:item.is_admin="{ item }">
                        <span :class="item.is_admin ? 'success--text' : ''">{{ item.is_admin ? 'Yes' : 'No' }}</span>
                    </template>
                    <template v-slot:item.status="{ item }">
                        <span :class="item.status === 'active' ? 'success--text' : 'error--text'">{{ item.status }}</span>
                    </template>
                    <template v-slot:item.office_id="{ item }">
                        {{ item.office_id ? offices.find(o => o.id === item.office_id).name : '' }}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="py-3">
                            <h2>Permissions</h2>
                            <div v-if="item.Roles[0] && item.Roles[0].Permissions">
                                <div v-for="group in getPermissionsByGroups(item.Roles[0].Permissions)" :key="group.id" class="mb-2">
                                  <h3>{{group.name}}:</h3>
                                  <v-chip-group column>
                                      <v-chip v-for="permission in group.permissions" :key="permission.id" color="primary" label>
                                          {{ permission.name }}
                                      </v-chip>
                                  </v-chip-group>
                                </div>
                            </div>
                            <div v-else>
                                This user doesn't have any permissions yet.
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </v-card>
            </v-container>
            <!-- END User data table -->
            <v-row justify="start">
                <v-col lg="4" class="text-center">
                    <v-pagination class="pagination-left" v-model="page" :length="pageCount"></v-pagination>
                </v-col>
            </v-row>
        </div>
    </main-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../../store';
import FormDialog from '../common/FormDialog.vue';
import MainLayout from '../layouts/MainLayout.vue';

export default {
  data() {
    return {
      valid: true,
      page: 1,
      pageCount: 0,
      search: '',
      tableItems: [],
      itemsPerPage: 25,
      expanded: [],
      headers: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Role',
          value: 'role',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Office',
          value: 'office_id',
        },
        {
          text: 'Is Admin',
          value: 'is_admin',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        email: '',
        is_admin: false,
        status: 'active',
        office_id: '',
        role_id: '',
      },
      defaultItem: {
        name: '',
        email: '',
        is_admin: false,
        status: 'active',
        office_id: '',
        role_id: '',
      },
      rules: {
        name: [
          (value) => Boolean(value) || 'Required.',
          (value) => (value || '').length <= 100 || 'Max 100 characters',
        ],
        email: [
          (value) => Boolean(value) || 'Required.',
          (value) => (value || '').length <= 80 || 'Max 80 characters',
          (value) => {
            // eslint-disable-next-line no-useless-escape
            const pattern = /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/;

            return pattern.test(value) || 'Invalid e-mail.';
          },
        ],
      },
      preloader: true,
      dialog: false,
      roles: [],
      formLoading: false,
      dataSent: false,
      successMessage: 'Data has been saved!',
    };
  },
  components: {
    MainLayout,
    FormDialog,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New User' : 'Edit User';
    },
    userStatusBool() {
      return this.editedItem.status === 'active';
    },
    ...mapGetters('roles', ['getRoles']),
    ...mapGetters('users', ['getUsers']),
    ...mapGetters('users', ['offices']),
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.tableItems.indexOf(item);
      this.editedItem = { ...item };
      this.editedItem.role_id = item.Roles.length ? item.Roles[0].id : '';
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.tableItems.indexOf(item);
      // eslint-disable-next-line no-alert
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.tableItems.splice(index, 1);
      }
    },
    close(form) {
      this.dialog = false;
      this.dataSent = false;
      this.$nextTick(() => {
        form.resetValidation();
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    async save(form) {
      if (!form.validate()) {
        return;
      }
      this.formLoading = true;
      if (this.editedIndex > -1) {
        // edit user
        await store.dispatch('users/updateUser', this.editedItem);
      } else {
        // new user
        await store.dispatch('users/createUser', this.editedItem);
      }
      this.formLoading = false;
      this.dataSent = true;
      setTimeout(() => {
        this.close(form);
      }, 2000);
    },
    handleStatusChange(value) {
      this.editedItem.status = value ? 'active' : 'inactive';
    },
    handleRoleClick(item) {
      if (this.expanded.includes(item)) {
        this.expanded.splice(this.expanded.indexOf(item), 1);
      } else {
        this.expanded.push(item);
      }
    },
    customFilter(value, search, item) {
      const searchVal = search.toString().toLowerCase();

      const officeFound = this.offices.find((office) => office.name.toString().toLowerCase().includes(searchVal));

      return item.name.toString().toLowerCase().includes(searchVal)
                    || item.email.toString().toLowerCase().includes(searchVal)
                    || item.status.toString().toLowerCase().includes(searchVal)
                    || item.id.toString().toLowerCase().includes(searchVal)
                    || officeFound && item.office_id === officeFound.id
                    || item.Roles.length && item.Roles[0].name.toString().toLowerCase().includes(searchVal);
    },
    getPermissionsByGroups(permissions) {
      const permissionsByGroup = [];

      permissions.forEach((permission) => {
        const permGroup = permissionsByGroup.find((pg) => pg.id === permission.Application.id);
        if (permGroup) {
          permGroup.permissions.push(permission);
        } else {
          permissionsByGroup.push({
            id: permission.Application.id,
            name: permission.Application.name,
            permissions: [permission],
          });
        }
      });

      return permissionsByGroup;
    },
  },
  async mounted() {
    this.preloader = true;
    await store.dispatch('users/getOffices');
    await store.dispatch('roles/saveRolesStore');
    await store.dispatch('users/saveUsersStore');
    this.roles = this.getRoles;
    this.tableItems = this.getUsers;
    this.preloader = false;
  },
  name: 'Users',
};
</script>

<style lang="sass"></style>
